import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Lock } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, EMAIL, EMAIL_MAILTO, COUNTIES, TAGLINE } from "@/lib/data";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-night text-ivory grain">
      <div className="relative z-[2] mx-auto max-w-7xl px-6 lg:px-12 pt-24 pb-12">
        <div className="grid md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-5">
            <img src="/prg-mark.png" alt="Property Resolutions Group" className="h-20 w-20 object-contain invert" />
            <p className="mt-4 text-[11px] tracking-[0.22em] uppercase text-sage">Property Resolutions Group</p>
            <p className="mt-2 font-serif italic text-lg text-sand">{TAGLINE}</p>
            <p className="mt-6 text-ivory/70 leading-relaxed max-w-sm text-sm">
              A Central Florida distressed property division helping homeowners navigate difficult
              situations with compassion, privacy, and confidence.
            </p>
            <div className="mt-6 flex items-center gap-2 text-ivory/60 text-sm">
              <Lock size={14} strokeWidth={1.75} className="text-sage" />
              Every conversation is confidential.
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="text-[11px] tracking-[0.22em] uppercase text-sage mb-5">Explore</p>
            <ul className="space-y-3 text-sm">
              <li><Link data-testid="footer-home-link" to="/" className="text-ivory/70 hover:text-ivory transition-colors duration-300">Home</Link></li>
              <li><Link data-testid="footer-about-link" to="/about" className="text-ivory/70 hover:text-ivory transition-colors duration-300">About</Link></li>
              <li><Link data-testid="footer-services-link" to="/services" className="text-ivory/70 hover:text-ivory transition-colors duration-300">Services</Link></li>
              <li><Link data-testid="footer-contact-link" to="/contact" className="text-ivory/70 hover:text-ivory transition-colors duration-300">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-[11px] tracking-[0.22em] uppercase text-sage mb-5">Reach us, your way</p>
            <ul className="space-y-4 text-sm">
              <li>
                <a href={PHONE_TEL} data-testid="footer-phone-link" className="flex items-center gap-3 text-ivory/70 hover:text-ivory transition-colors duration-300">
                  <Phone size={15} strokeWidth={1.75} className="text-sage" /> {PHONE_DISPLAY}
                </a>
              </li>
              <li>
                <a href={EMAIL_MAILTO} data-testid="footer-email-link" className="flex items-center gap-3 text-ivory/70 hover:text-ivory transition-colors duration-300">
                  <Mail size={15} strokeWidth={1.75} className="text-sage" /> {EMAIL}
                </a>
              </li>
              <li className="flex items-start gap-3 text-ivory/70">
                <MapPin size={15} strokeWidth={1.75} className="text-sage mt-0.5 shrink-0" />
                Serving {COUNTIES.join(", ")} counties, Florida
              </li>
              <li className="text-ivory/50 text-xs pl-7">In affiliation with KW Smart 1 Realty · Winter Haven, FL</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-ivory/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-ivory/50">
          <p>© {new Date().getFullYear()} Property Resolutions Group. All rights reserved.</p>
          <div className="flex gap-6">
            <Link data-testid="footer-privacy-link" to="/privacy" className="hover:text-ivory transition-colors duration-300">Privacy Policy</Link>
            <Link data-testid="footer-terms-link" to="/terms" className="hover:text-ivory transition-colors duration-300">Terms of Use</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
